// src/hooks/useBlogPreviewImage.ts
import { useState, useEffect } from 'react';

const getRandomImage = (): string => {
  const randomImages = [
    'anne-nygard-tcJ6sJTtTWI-unsplash.jpg',
    'hans-eiskonen-wn57cSQ7VzI-unsplash.jpg',
    'jakub-zerdzicki-U4-I4oH4xlg-unsplash.jpg',
    'jakub-zerdzicki-ip7GFn5JqX8-unsplash.jpg',
    'jamie-street-VP4WmibxvcY-unsplash.jpg',
    'kelly-sikkema-zcAgxLryKe4-unsplash.jpg',
    'maxim-hopman-fiXLQXAhCfk-unsplash.jpg',
    'nicholas-cappello-Wb63zqJ5gnE-unsplash.jpg',
    'nimisha-mekala-fchVIvuMGBI-unsplash.jpg',
    'yorgos-ntrahas-lp8ZlyAZjy8-unsplash.jpg'
  ];
  
  const randomIndex = Math.floor(Math.random() * randomImages.length);
  return `/random_images/${randomImages[randomIndex]}`;
};

export const useBlogPreviewImage = (s3Url: string) => {
  const [image, setImage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchHeadlineImage = async () => {
      try {
        setLoading(true);
        
        // Fetch the HTML content
        const response = await fetch(s3Url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const htmlContent = await response.text();
        
        // Parse HTML to extract headline image
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        
        const headlineImageMeta = doc.querySelector('meta[name="headline_image_date"]');
        let headlineImage = headlineImageMeta?.getAttribute('content') || '';
        
        // If no headline image found, use random image
        if (!headlineImage) {
          headlineImage = getRandomImage();
        }
        
        setImage(headlineImage);
      } catch (error) {
        console.error('Error fetching preview image:', error);
        // Fallback to random image on error
        setImage(getRandomImage());
      } finally {
        setLoading(false);
      }
    };

    fetchHeadlineImage();
  }, [s3Url]);

  return { image, loading };
};